<template>
  <div>
    <v-menu
      v-model="di"
      :close-on-content-click="false"
      :nudge-right="40"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="dataInicio"
          label="Data inicial"
          prepend-icon="event"
          readonly
          v-on="on"
        />
      </template>
      <v-date-picker no-title @input="selecionarDataInicio" />
    </v-menu>
    <v-menu
      v-model="df"
      :close-on-content-click="false"
      :nudge-right="40"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="dataFim"
          label="Data final"
          prepend-icon="event"
          readonly
          v-on="on"
        />
      </template>
      <v-date-picker no-title @input="selecionarDataFim" :min="dataInicioSelecionada" />
    </v-menu>
    <v-select
      :items="comparadores"
      label="Quantidade de pedidos"
      item-text="text"
      item-value="value"
      v-model="comparadorSelecionado"
    />
    <div v-show="showQuantidadePedidosField">
      <v-text-field
        label="Quantidade"
        type="number"  
        v-model="quantidadeSelecionada"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FiltroPeriodoPedidos',
  data() {
    const hoje = new Date().toLocaleDateString()
    return {
      di: false,
      df: false,
      dataInicio: hoje,
      dataFim: hoje,
      comparadores: [
        {
          text: 'Não comparar',
          value: null
        },
        {
          text: 'Igual a',
          value: '='
        },
        {
          text: 'Maior que',
          value: '>'
        },
        {
          text: 'Menor que',
          value: '<'
        }
      ],

      dataInicioSelecionada: this.parseData(hoje),
      dataFimSelecionada: this.parseData(hoje),
      comparadorSelecionado: null,
      quantidadeSelecionada: 0
    }
  },
  mounted() {
    this.$emit('filtrar-periodo-pedidos', {
      data_inicio: this.dataInicioSelecionada,
      data_fim: this.dataFimSelecionada
    })
  },
  computed: {
    tudo() {
      return `${this.dataInicioSelecionada}|${this.dataFimSelecionada}|${this.comparadorSelecionado}|${this.quantidadeSelecionada}`
    },
    showQuantidadePedidosField() {
      return this.comparadorSelecionado !== null
    }
  },
  watch: {
    tudo() {
      const di = this.toDate(this.dataInicioSelecionada)
      const df = this.toDate(this.dataFimSelecionada)
      if (di > df) {
        return
      }
      this.$emit('filtrar-periodo-pedidos', {
        data_inicio: this.dataInicioSelecionada,
        data_fim: this.dataFimSelecionada,
        comparador_pedidos: this.comparadorSelecionado,
        quantidade_pedidos: parseInt(this.quantidadeSelecionada)
      })
    }
  },
  methods: {
    parseData(data) {
      let [dia, mes, ano] = data.split('/')
      return `${ano}-${mes}-${dia}`
    },
    selecionarDataInicio(value) {
      const di = this.toDate(value)
      const df = this.toDate(this.dataFimSelecionada)
      this.dataInicio = di.toLocaleDateString()
      this.dataInicioSelecionada = value
      this.di = false
      
      if (di > df) {
        this.selecionarDataFim(value)
      }
    },
    selecionarDataFim(value) {
      this.dataFim = this.toDate(value).toLocaleDateString()
      this.dataFimSelecionada = value
      this.df = false
    },
    toDate(value) {
      return new Date(value + 'T00:00')
    }
  }
}
</script>
